import { CheckCircle, Circle } from "lucide-react";
import { useFetcher } from "react-router-dom";

interface MarkCompleteProps {
  lectureId: string;
  isCompleted: boolean | null;
}
export function MarkComplete({ lectureId, isCompleted }: MarkCompleteProps) {
  const fetcher = useFetcher();
  const isCompletedOptimistic = fetcher.formData ? !isCompleted : isCompleted;
  return (
    <fetcher.Form method="put">
      <input
        type="hidden"
        name="isCompleted"
        value={isCompletedOptimistic!.toString()}
      />
      <input type="hidden" name="intent" value="mark-complete" />
      <input type="hidden" name="lectureId" value={lectureId} />
      <button type="submit" disabled={fetcher.state === "submitting"}>
        {isCompletedOptimistic ? (
          <CheckCircle className="w-4 h-4 text-green-500 flex-shrink-0" />
        ) : (
          <Circle className="w-4 h-4 text-gray-400 group-hover:text-gray-600 flex-shrink-0" />
        )}
      </button>
    </fetcher.Form>
  );
}
